module.exports = __webpack_public_path__ + "img/pic5.6d192f82.jpg";